import { createContext } from "react";

/**
 * How far above its own frame a page scroller may reach to meet the window's top edge: the height
 * of the app shell's status-bar spacer above the screens. A scroller beneath floating glass chrome
 * extends by this much, so content passes under the status bar too and UIKit's scroll edge effect
 * covers it, as it does under a system navigation bar. `0` wherever nothing sits above the screens
 * (and outside the app shell).
 */
export const ScrollEdgeTopExtensionContext = createContext(0);

/** Safe-area clearance inside a viewport that already reaches the window's top edge. */
export const ScrollEdgeTopInsetContext = createContext(0);
